module.exports = __webpack_public_path__ + "media/assets/images/flags/us-80443fcc243902af23bf464e7a8dc01b.svg";